// extracted by mini-css-extract-plugin
export default {"genderContainer":"DistributionByGender_genderContainer__m6+w-"};